import { useCallback, useEffect, useRef, useState } from 'react';
import { useLazyGetVehicleWarrantyInformationQuery } from '../../../../api/endpoints/vehicleWarrantyInformationReport';

const useVehicleWarrantyInfoData = (chassisNo, dialogVisible) => {
    const [fetchWarrantyInfo] = useLazyGetVehicleWarrantyInformationQuery();
    const [visible, setVisible] = useState(false);
    const [items, setItems] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isError, setIsError] = useState(false);
    const requestId = useRef(0);
    const selectedChassisNo = String(chassisNo || '').trim();

    const hide = useCallback(() => {
        requestId.current += 1;
        setVisible(false);
        setItems([]);
        setIsLoading(false);
        setIsError(false);
    }, []);

    useEffect(() => {
        hide();
    }, [selectedChassisNo, dialogVisible, hide]);

    const open = useCallback(async () => {
        if (!selectedChassisNo) return;

        const currentRequestId = ++requestId.current;
        setVisible(true);
        setItems([]);
        setIsError(false);
        setIsLoading(true);

        try {
            const result = await fetchWarrantyInfo({ sasiNo: selectedChassisNo, pageNumber: 1, pageSize: 10 }).unwrap();
            if (requestId.current === currentRequestId) setItems(result.items);
        } catch {
            if (requestId.current === currentRequestId) setIsError(true);
        } finally {
            if (requestId.current === currentRequestId) setIsLoading(false);
        }
    }, [fetchWarrantyInfo, selectedChassisNo]);

    return { visible, items, isLoading, isError, open, hide };
};

export default useVehicleWarrantyInfoData;
